import React from 'react';
import { MessageCircle } from 'lucide-react';

export const HandoffButton = ({ onClick }) => (
  <div className="px-4 pb-3 pt-1">
    <button
      type="button"
      onClick={onClick}
      className="w-full py-3.5 rounded-full bg-gradient-to-r from-[#F3E5AB] via-[#D4AF37] to-[#AA8022] text-black font-semibold text-sm flex items-center justify-center gap-2 hover:shadow-lg transition-shadow duration-200"
      data-testid="continue-whatsapp-btn"
    >
      <MessageCircle className="w-4 h-4" />
      Continue on WhatsApp
    </button>
    <p className="text-[10px] uppercase tracking-[0.2em] text-white/40 text-center mt-2">
      Your details will be pre-filled
    </p>
  </div>
);
